<div *ngFor="let color of colors; let idx = index" panel>
  <button (click)="clickActivate(idx)"
          [ngStyle]="{color: color?.btnForeColor}">
    <div checkers></div>
    <div [class]="color?.btnClass" [ngStyle]="{backgroundColor: color?.btnBackColor}" back></div>
    <mat-icon>{{ color?.icon ?? 'palette' }}</mat-icon>
  </button>
</div>
